import {
  Flex,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useColorModeValue,
  useToast,
  Tooltip,
} from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import { AddIcon } from '@chakra-ui/icons';
import AddModal from './addModal';
// Custom components
import StoresApi from 'api/stores';
import CompaniesApi from 'api/companies';
import SavingsPlanApi from 'api/savingplan';
import SavingPlanVariantApi from 'api/savingplanvariant';
import SavingsPlanStoreApi from 'api/savingplanstore';
import MultiSelect from 'components/autocomplete/autocomplete';
import { Modules } from 'config/constant';
import { usePermissions } from 'contexts/PermissionContext';
import NoPermissionsMessage from 'components/nopermission/NoPermissions';
import TableWrapper from 'components/tableWrapper/tableWrapper';
import PageError from 'components/nopermission/PageError';

export default function TableData(props) {
  const { secondary } = props;
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
  const [isError, setIsError] = useState('');
  const [list, setList] = useState([]);
  const [name, setName] = useState();
  const [displayOrder, setDisplayOrder] = useState();
  const [loading, setLoading] = useState(false);
  const toast = useToast();
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(100);
  const [listTotal, setListTotal] = useState(2);
  // const [totalPages, setTotalPages] = useState(0);
  const [error, setError] = useState(false);
  const [searchTerm, setSearchTerm] = useState('');
  const [savingPlanList, setSavingplanList] = useState([]);
  const [variantList, setvariantList] = useState([]);
  const [storeList, setStoreList] = useState([]);
  const [companiesList, setcompaniesList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState();
  const { getPermissionsForModule } = usePermissions();
  const [variantStorePermissions, setvariantStorePermissions] = useState(null);
  const [fetchVariantStoreListError, setfetchVariantStoreListError] =
    useState(false);

  const FetchStoreList = async () => {
    try {
      setLoading(true);
      let response = await StoresApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setStoreList(response?.data?.list);
        setListTotal(response?.data?.total);
        // console.log(list);
      } else {
        setStoreList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const FetchCompanies = async () => {
    try {
      setLoading(true);
      let response = await CompaniesApi.List({});
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setcompaniesList(response?.data?.list);
        setListTotal(response?.data?.total);
        // console.log(list);
      } else {
        setcompaniesList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchVariantList = async () => {
    try {
      setLoading(true);
      let response = await SavingPlanVariantApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setvariantList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setvariantList(null);
        setListTotal(0);
      }
    } catch (err) {
      console.log(err);
    }
  };
  const fetchVariantStoreList = async () => {
    try {
      setLoading(true);
      let response = await SavingsPlanStoreApi.List({
        currentPage,
        itemsPerPage,
        sort: 'name:asc',
        searchTerm,
        selectedCompany,
      });
      response = response.data;
      setLoading(false);
      if (response.status_code === 200) {
        setfetchVariantStoreListError(false);
        setList(response?.data?.list);
        setListTotal(response?.data?.total);
      } else {
        setfetchVariantStoreListError(true);
        setList(null);
        setListTotal(0);
      }
    } catch (err) {
      setfetchVariantStoreListError(true);
      console.log(err);
    }
  };

  const FetchSavingPlanList = async () => {
    try {
      let response = await SavingsPlanApi.List({
        currentPage: 1,
        itemsPerPage: 10,
        sort: 'name:asc',
      });
      response = response.data;
      if (response.status_code === 200 && response?.data?.list?.length > 0) {
        setSavingplanList(response?.data?.list);
      } else {
        setSavingplanList([]);
      }
    } catch (err) {
      console.log(err);
      setSavingplanList([]);
    }
  };

  const generateObjects = (companiesList) => {
    console.log('sorted companies', companiesList);
    if (!companiesList) {
      return [];
    }
    const obj = {
      value: '',
      label: 'Select Company',
    };
    const periodMap = companiesList?.map((period) => ({
      label: period.name,
      value: period.id,
    }));
    console.log('Distinct period objects', periodMap);
    return [obj, ...periodMap];
  };

  useEffect(() => {
    FetchStoreList();
    FetchCompanies();
    fetchVariantList();
    FetchSavingPlanList();
  }, [selectedCompany]);

  useEffect(() => {
    const variantStorePermissions = getPermissionsForModule([
      Modules.SavingPlanStore,
    ]);
    setvariantStorePermissions(variantStorePermissions);
  }, [getPermissionsForModule]);

  useEffect(() => {
    if (variantStorePermissions?.read) {
      fetchVariantStoreList();
    }
  }, [currentPage, searchTerm, variantStorePermissions]);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm, selectedCompany]);

  function getPropertyFromId(inputId, objects, property) {
    console.log('Params', inputId, objects, property);
    if (objects) {
      for (const obj of objects) {
        if (obj.id === inputId) {
          return obj[property];
        }
      }
    }
    return null; // Return null if ID not found
  }

  const handleSearch = async (search) => {
    setSearchTerm(search);
  };

  if (!variantStorePermissions?.read) {
    return <NoPermissionsMessage module={Modules.SavingPlanStore} />;
  }

  console.log('permission', variantStorePermissions);

  return fetchVariantStoreListError ? (
    <PageError />
  ) : (
    <Flex
      height='100%'
      mt='8rem'
      direction='column'>
      <Flex
        direction={{ sm: 'column', md: 'row' }}
        px={5}
        mb='20px'
        width='100%'
        gap={10}>
        <Flex>
          <MultiSelect
            options={generateObjects(companiesList)}
            isMulti={false}
            placeholder='Select Company'
            value={selectedCompany}
            onChange={setSelectedCompany}
          />
        </Flex>
        <Flex ml='auto'>
          <Tooltip
            label={
              !variantStorePermissions.create
                ? 'You do not have permission to add'
                : undefined
            }
            placement='top'
            shouldWrapChildren>
            <AddModal
              Icon={<AddIcon />}
              head={'Add New Branch to Plan'}
              func={fetchVariantStoreList}
              companiesList={companiesList}
              planList={savingPlanList}
              disabled={
                !variantStorePermissions.create || !variantStorePermissions.read
              }
            />
          </Tooltip>
        </Flex>
      </Flex>
      <TableWrapper
        list={list}
        loading={loading}
        currentPage={currentPage}
        setCurrentPage={setCurrentPage}
        listTotal={listTotal}
        itemsPerPage={itemsPerPage}
        isError={isError}>
        <Table
          variant='striped'
          color='gray.500'
          mb='24px'>
          <Thead>
            <Tr>
              <Th
                pe='1px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Sr.no
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Company
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Branch
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Variant
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Display Order
                </Flex>
              </Th>
              <Th
                pe='10px'
                borderColor={borderColor}>
                <Flex
                  justify='space-between'
                  align='center'
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color='gray.400'>
                  Status
                </Flex>
              </Th>
              {/* <Th pe='10px' borderColor={borderColor}>
              <Flex
                justify='space-between'
                align='center'
                fontSize={{ sm: '10px', lg: '12px' }}
                color='gray.400'
              >
                Actions
              </Flex>
            </Th> */}
            </Tr>
          </Thead>

          <Tbody>
            {list?.map((obj, index) => {
              console.log('Object', obj);
              return (
                <Tr key={obj.id}>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {(currentPage - 1) * 10 + (index + 1)}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.company_name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.store_name}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.saving_plan_category} - {obj.saving_plan_variant_period} months
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Flex align='center'>
                      <Text
                        me='10px'
                        color={textColor}
                        fontSize='sm'
                        fontWeight='700'>
                        {obj.display_order}
                      </Text>
                    </Flex>
                  </Td>
                  <Td>
                    <Text
                      size='sm'
                      fontWeight='700'
                      color={obj.is_active === true ? 'green' : { textColor }}>
                      {obj.is_active === true ? 'ACTIVE' : 'INACTIVE'}
                    </Text>
                  </Td>
                </Tr>
              );
            })}
          </Tbody>
        </Table>
      </TableWrapper>
    </Flex>
  );
}
